import { IPublicClientApplication } from "@azure/msal-browser";

import { axiosGetRequest, axiosPostRequest } from "../../api/ApiClient";
import GenericUtils from "../../utils/GenericUtils";

const route = "/docente/v1/";
const report = "relatorios";

const postReport = (
    msalInstance: IPublicClientApplication,
    filteredItem: object
) => {
    return axiosPostRequest(
        `${route}relatorioprocessos`,
        filteredItem,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
};

const getReportData = (instance: IPublicClientApplication) => {
    return axiosGetRequest(
        `${route}${report}`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
};

const getTypeReport = (instance: IPublicClientApplication) => {
    return axiosGetRequest(
        `${route}relatoriotipos`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
};

const getActivityRoute = (
    instance: IPublicClientApplication,
    hasStudents = false
) => {
    const queryParam = hasStudents
        ? ` and temEstudante="S"`
        : ` and temEstudante="N"`;
    return axiosGetRequest(
        `${route}atividades?maxResults=99999&orderBy=descricao&query=ativo="S"${queryParam}`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
};

const getResultCenterRoute = (instance: IPublicClientApplication) => {
    return axiosGetRequest(
        `${route}centroresultados?&_limit=999999`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
};

const getResultCampus = (instance: IPublicClientApplication) => {
    return axiosGetRequest(
        `${route}campi?&_limit=999999`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
};

const getProfessorRoute = (instance: IPublicClientApplication) => {
    return axiosGetRequest(
        `${route}professores?&_limit=999999`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
};

const getUsersRoute = (instance: IPublicClientApplication) => {
    return axiosGetRequest(
        `${route}usuarios?orderBy=nome&sortOrder=ASCENDING&maxResults=5000&page=1&query=listaPerfis(idPerfil%20in%20(1))`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
};

const getBonusRoute = (instance: IPublicClientApplication) => {
    return axiosGetRequest(
        `${route}tipo-abono`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
};

const getModalityRoute = (instance: IPublicClientApplication) => {
    return axiosGetRequest(
        `${route}modalidades`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
};

const getCoordinatorRoute = (instance: IPublicClientApplication) => {
    return axiosGetRequest(
        `${route}docentes?perfis=4&_limit=999999999`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
};

export default {
    getReportData,
    getTypeReport,
    getActivityRoute,
    getCoordinatorRoute,
    getResultCenterRoute,
    getResultCampus,
    getProfessorRoute,
    getUsersRoute,
    getBonusRoute,
    getModalityRoute,
    postReport,
};
